import i18n from "i18next";
import { getUserEnv } from "./getUserEnv";

export const trackCheckoutEvent = ({ eventType, price, output }) => {
  if (!eventType || typeof price !== "number" || !output) return;

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: eventType,
    timestamp: new Date().toISOString(),
    price: price,
    output: output,
    user_env: getUserEnv(),
    user_language: i18n.language,
  });
};
